// extracted by mini-css-extract-plugin
var _1 = "MbTJM";
export { _1 as "base" }
